module.exports = __webpack_public_path__ + "static/media/entree-bulletinboard.b061123d.svg";